module.exports = __webpack_public_path__ + "static/media/bowling-pins.fc1c4ac4.svg";